
// _context/useSystem.js
import { useContext } from 'react';
import SystemContext from './systemContext';

export const useSystem = () => {
  const context = useContext(SystemContext);
  if (!context) {
    throw new Error('useSystem debe ser usado dentro de un SystemProvider');
  }
  return context;
};